<template>
  <!-- <div class="card-wrapper"> -->
    <card type="goals">
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon :icon="icon" />
          </div>
          <h4 class="card-title">{{title}}</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(metric) }}</h1>
          <p>{{ description }}</p>
        </div>
      </card>
  <!-- </div> -->
</template>
<script>
export default {
  name: "card-metric",
  props: {
    title: String,
    icon: String,
    metric: Number,
    description: String
  },
  methods: {
    numberLetter(value) {
      let suffixes = [
        "U",
        "D",
        "C",
        "K",
        "K",
        "K",
        "M",
        "M",
        "M",
        "B",
        "B",
        "B",
        "T",
        "T",
        "T"
      ];

      let stringValue = value.toString();
      let valueLength = stringValue.length;

      if (stringValue.includes(".") & (valueLength <= 4)) {
        return stringValue;
      }

      let suffix = suffixes[valueLength - 1];

      const BASEDIVISOR = 3;
      let startindex = 0;
      let characterToTake = valueLength % BASEDIVISOR;
      characterToTake = characterToTake == 0 ? BASEDIVISOR : characterToTake;

      if (valueLength > BASEDIVISOR) {
        let wholePart = stringValue.substr(startindex, characterToTake);
        let decimalPart = stringValue.substr(
          startindex + characterToTake,
          BASEDIVISOR
        );

        let firstDecimal = decimalPart.substr(startindex, 1);

        let wholeNumber =
          firstDecimal != "0"
            ? wholePart + "." + decimalPart.substr(startindex, 1) + suffix
            : wholePart + suffix;

        return wholeNumber;
      }

      return stringValue;
    }
  }
};
</script>
<style lang="scss" scoped>
.big-padding {
  padding: $big-padding;
}
p {
  margin-bottom: 15px;
  &:last-child {
    margin-bottom: 0px;
  }
}

.card-content {
  text-align: center;
  h1 {
    span {
      font-size: 35px;
    }
    font-size: 52px;
    font-weight: $font-medium;

    color: $highlight-color;
  }
}
.card-number {
  text-align: center;
  h3 {
    color: $highlight-color;
  }
}

// .widget {
//   &.widget-goals {
//     .card-goals {
      
//     }
//   }
//   &.brand-impact {
//     .card-line-chart {
//       .card-top {
        
//       }
//     }
//   }
// }
@include respond-above(sm) {
  .widget-goals {
      .cards-wrapper {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 20px;
      }
    }
  // .widget {
  //   &
  // }
}
</style>
